// extracted by mini-css-extract-plugin
module.exports = {"AnnouncementBar":"AnnouncementBar-module--AnnouncementBar--oaF1o","AnnouncementContent":"AnnouncementBar-module--AnnouncementContent--3RsPH"};